import React from "react";
import { Row, Col, Card, Input, Drawer, Badge, Skeleton } from "antd";
import Scrollbars from "react-custom-scrollbars";
import { CloseOutlined, CloseSquareFilled, StarOutlined } from "@ant-design/icons";
import SearchIcon from "../../../../assets/images/searchIcon.svg";
import DefaultProductImage from "../../../../assets/images/no-image.svg";
import removeBg from "../../../../assets/images/removebg.png";
import vegIcon from "../../../../assets/images/veg.png";
import eggIcon from "../../../../assets/images/egg.png";

const getFoodTypeIcon = (foodType) => {
  if (!foodType) return null;
  if (foodType === "VEG") return vegIcon;
  if (foodType === "NVG") return removeBg;
  if (foodType === "EGG") return eggIcon;
  return null;
};

const ProductPanelDrawer = ({
  filterDrawer,
  setFilterDrawer,
  productSearchInput,
  setProductSearchInput,
  selectCategotyList,
  setSelectCategotyList,
  setProductsData,
  saleTypeProducts,
  loading,
  productPanelSearchRef,
  setOpen,
  setInputName,
  keyboard,
  applySearchFilter,
  productCategoriesList,
  setCategorieName,
  restaurantProductCategory,
  setCategorieFlag,
  frequentProducts,
  nonfrequentProducts,
  showImage,
  currenciesList,
  getColorFromId,
  handleAddOnModal,
  pickProduct,
}) => {
  return (
    <Drawer
      placement="bottom"
      closable={false}
      maskClosable={false}
      className="filter"
      styles={{ body: { paddingBottom: 0 } }}
      onClose={() => {
        setFilterDrawer(false);
        setProductSearchInput("");
        setSelectCategotyList([]);
        setProductsData(saleTypeProducts);
      }}
      id="sm-drawer-close"
      height="89vh"
      open={filterDrawer}
    >
      <Col span={24} style={{ fontSize: "1vw", padding: "0 2vw", height: "83vh" }}>
        {loading ? (
          <>
            {[...Array(12)].map((_, index) => (
              <Card key={index} style={{ marginBottom: "1vh", padding: "12px", borderRadius: "8px" }}>
                <Skeleton active paragraph={{ rows: 2 }} />
              </Card>
            ))}
          </>
        ) : (
          <>
            {/* Close button */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
              <CloseOutlined
                onClick={() => {
                  setFilterDrawer(false);
                  setProductSearchInput("");
                  setSelectCategotyList([]);
                  setProductsData(saleTypeProducts);
                }}
                style={{ fontSize: "1.2vw", cursor: "pointer" }}
              />
            </div>

            {/* Search + Sort */}
            <Row style={{ marginBottom: "1vh", width: "100%", display: "flex", alignItems: "center" }}>
              <Col span={24}>
                <Input
                  ref={productPanelSearchRef}
                  placeholder="Search for products by code/name"
                  id="sm-product-search"
                  value={productSearchInput}
                  onChange={(e) => {
                    setProductSearchInput(e.target.value.toLowerCase());
                  }}
                  style={{
                    width: "100%",
                    borderRadius: "7px",
                    padding: "0.8vh 0.8vw",
                    borderColor: "#fff",
                    backgroundColor: "#fff",
                    height: "5vh",
                    fontSize: "1em",
                  }}
                  onFocus={() => {
                    setOpen(true);
                    setTimeout(() => {
                      setInputName("productSearch1");
                      keyboard?.current?.setInput(productSearchInput);
                    }, 150);
                  }}
                  onPressEnter={() => {
                    const filtered = applySearchFilter(productSearchInput, selectCategotyList);
                    setProductsData(filtered);
                    keyboard?.current?.setInput(productSearchInput);
                  }}
                  prefix={
                    <img
                      src={SearchIcon}
                      alt=""
                      onClick={() => {
                        const value = productSearchInput.toLowerCase().trim();
                        const filtered = saleTypeProducts.filter((product) => {
                          const matchesText =
                            product.name.toLowerCase().includes(value) || product.value?.toLowerCase().includes(value) || product.code?.toLowerCase().includes(value);
                          const matchesCategory = selectCategotyList.length === 0 || selectCategotyList.includes(product.mProductCategoryId);
                          return matchesText && matchesCategory;
                        });
                        setProductsData(filtered);
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  }
                  suffix={
                    productSearchInput?.length > 0 ? (
                      <CloseSquareFilled
                        style={{ fontSize: "20px", color: "#2F3856" }}
                        onClick={async () => {
                          setProductSearchInput("");
                          if (selectCategotyList.length === 0) {
                            setProductsData(saleTypeProducts);
                          } else {
                            setProductsData(saleTypeProducts.filter((product) => selectCategotyList.includes(product.mProductCategoryId)));
                          }
                          setTimeout(() => {
                            setOpen(false);
                            const productSearchInput = document.getElementById("sm-product-search");
                            if (productSearchInput) {
                              productSearchInput.blur();
                            }
                            keyboard?.current?.setInput("");
                          }, 200);
                        }}
                      />
                    ) : null
                  }
                />
              </Col>
            </Row>

            {/* Categories */}
            <div style={{ display: "flex", overflowX: "auto", paddingBottom: "1%", paddingLeft: "0.1rem" }}>
              {productCategoriesList
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((category) => (
                  <button
                    key={category.mProductCategoryId}
                    onClick={() => {
                      const newCategory = [category.mProductCategoryId];
                      setSelectCategotyList(newCategory);
                      setCategorieName(category.name);
                      restaurantProductCategory(category.mProductCategoryId);
                      setCategorieFlag(true);
                      const filtered = applySearchFilter(productSearchInput, newCategory);
                      setProductsData(filtered);
                    }}
                    style={{
                      background: selectCategotyList.includes(category.mProductCategoryId) ? "#eff6ff" : "#fff",
                      color: selectCategotyList.includes(category.mProductCategoryId) ? "#2563eb" : "#0F0718",
                      fontWeight: 500,
                      border: "none",
                      padding: "0.5vh 0.5vw",
                      height: "6vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      fontSize: "1em",
                      fontFamily: "Inter",
                      cursor: "pointer",
                    }}
                  >
                    {category.name}
                    <Badge
                      count={saleTypeProducts.filter((product) => product.mProductCategoryId === category.mProductCategoryId).length}
                      style={{
                        backgroundColor: "#f5f5f5",
                        color: "#0F0718",
                        fontSize: "0.8em",
                        padding: "0px 8px",
                        borderRadius: "10px",
                        marginLeft: "0.5em",
                      }}
                    />
                  </button>
                ))}
            </div>

            {/* Product Grid */}
            <Scrollbars style={{ height: "65vh" }}>
              {(() => {
                // Helper: Minimal card when showImage is N
                const MinimalCard = ({ product }) => (
                  <Card
                    key={product.mProductId}
                    style={{
                      borderRadius: "10px",
                      border: "1px solid #e8e8e8",
                      padding: "10px",
                      cursor: "pointer",
                      color: "#0F0718",
                      fontWeight: "500",
                      backgroundColor: getColorFromId(product.mProductId),
                      overflow: "hidden",
                      height: "90px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      position: "relative",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      product?.productAddons?.length > 0 && product?.showAddons === "Y" ? handleAddOnModal(product, e) : pickProduct(product);
                    }}
                  >
                    <p
                      title={product.name}
                      style={{
                        fontWeight: 500,
                        fontSize: "13px",
                        margin: 0,
                        lineHeight: "1.4",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        padding: "0 4px",
                      }}
                    >
                      {product.name}
                    </p>

                    <p
                      style={{
                        color: "green",
                        fontWeight: 500,
                        fontSize: "12px",
                        margin: 0,
                        position: "absolute",
                        bottom: "8px",
                        right: "10px",
                      }}
                    >
                      {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                      {product.sunitprice.toFixed(2)}
                      {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                    </p>
                  </Card>
                );

                // Helper: Rich card when showImage is Y
                const RichCard = ({ product }) => (
                  <Card
                    key={product.mProductId}
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #e8e8e8",
                      cursor: "pointer",
                      position: "relative",
                      padding: "12px",
                      overflow: "visible",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      product?.productAddons?.length > 0 && product?.showAddons === "Y" ? handleAddOnModal(product, e) : pickProduct(product);
                    }}
                  >
                    <div
                      style={{
                        height: "60px",
                        background: "#f5f5f5",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                        overflow: "visible",
                        position: "relative",
                      }}
                    >
                      <img
                        src={product.imageurl || DefaultProductImage}
                        alt={product.name}
                        style={{
                          width: product.imageurl ? "100%" : "40px",
                          height: product.imageurl ? "100%" : "40px",
                          objectFit: product.imageurl ? "cover" : "contain",
                          margin: product.imageurl ? "0" : "auto",
                        }}
                      />
                      {product.isBestSeller && (
                        <div
                          style={{
                            position: "absolute",
                            top: "4px",
                            right: "4px",
                            backgroundColor: "#eab308",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "10px",
                            fontSize: "10px",
                            fontWeight: 500,
                            zIndex: 1,
                            pointerEvents: "none",
                          }}
                        >
                          <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                          Best
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <h3
                        title={product?.name}
                        style={{
                          fontSize: "0.8em",
                          fontWeight: "600",
                          color: "#0F0718",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {product.name}
                      </h3>
                      <div style={{ fontSize: "0.8rem", color: "#4b5563", marginBottom: "0.25rem" }}>
                        <span style={{ fontWeight: "500" }}>{product.value}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontSize: "0.9em", fontWeight: "700", color: "#389e0d" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                          {product.sunitprice.toFixed(2)}
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                        </span>
                        <Col
                          span={2}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "2px",
                          }}
                        >
                          {getFoodTypeIcon(product.foodType) && <img src={getFoodTypeIcon(product.foodType)} style={{ height: "1.8vh" }} />}
                        </Col>
                      </div>
                    </div>
                  </Card>
                );

                // Render Best Sellers
                const renderBestSellers = () => {
                  const filtered = frequentProducts.filter((p) => selectCategotyList.length === 0 || selectCategotyList.includes(p.mProductCategoryId));
                  if (filtered.length === 0) return null;

                  return (
                    <div style={{ marginBottom: "2vh" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "3px", marginBottom: "1vh" }}>
                        <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>Best Sellers</h2>
                        <Badge
                          count={filtered.length}
                          style={{
                            backgroundColor: "#f5f5f5",
                            color: "#0F0718",
                            fontSize: "0.8em",
                            padding: "0px 8px",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                        {filtered.map((product) =>
                          showImage ? <RichCard key={product.mProductId} product={product} /> : <MinimalCard key={product.mProductId} product={product} />
                        )}
                      </div>
                    </div>
                  );
                };

                // Render All Products
                const renderAllProducts = () => {
                  const filtered = nonfrequentProducts.filter((p) => selectCategotyList.length === 0 || selectCategotyList.includes(p.mProductCategoryId));
                  if (filtered.length === 0) return null;

                  return (
                    <div style={{ marginBottom: "2vh" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "3px", marginBottom: "1vh" }}>
                        <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>All Products</h2>
                        <Badge
                          count={filtered.length}
                          style={{
                            backgroundColor: "#f5f5f5",
                            color: "#0F0718",
                            fontSize: "0.8em",
                            padding: "0px 8px",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                        {filtered.map((product) =>
                          showImage ? <RichCard key={product.mProductId} product={product} /> : <MinimalCard key={product.mProductId} product={product} />
                        )}
                      </div>
                    </div>
                  );
                };

                return (
                  <>
                    {renderBestSellers()}
                    {renderAllProducts()}
                  </>
                );
              })()}
            </Scrollbars>
          </>
        )}
      </Col>
    </Drawer>
  );
};

export default ProductPanelDrawer;
